import * as React from "react"
import {
    Box,
    Text,
    VStack,
    Code,
    Grid,
    theme,
} from "@chakra-ui/react"
import { ColorModeSwitcher } from "./ColorModeSwitcher"
import { Logo } from "./Logo"
import { Button, ButtonGroup } from "@chakra-ui/react"
import { Link } from 'react-router-dom';
import { Heading, Center } from "@chakra-ui/react"
import styled from 'styled-components';

const Column = styled.div`
    text-align: center;
`

const Bar = styled.div`
    margin-top: 1vh;
    margin-bottom: 1vh;

`

const Rim = styled.div`
    border-style: solid;
    margin-top: 5vh;
`

const bstyle = {
    backgrounColor: '#4c4c4c',
}

const Splash = () => (
    <Box textAlign="center" fontSize="xl">
        <Rim>
            <Grid minH="100vh" p={3}>
                <Column>
                    <Center>
                        <div>
                            <Bar>
                                <img src="tripped.png" alt="desintation map shown" />
                            </Bar>
                        </div>
                    </Center>
                    <Bar>
                        <Link to="/login"><Button width="200px" colorScheme="teal">Sign Up</Button></Link>
                    </Bar>
                    <Bar>
                        <Link to="/login"><Button width="200px" colorScheme="gray">Continue with Google</Button></Link>
                    </Bar>
                    <Bar>
                        <Link to="/login"><Button width="200px" colorScheme="gray" >Continue with Apple</Button></Link>
                    </Bar>
                    <Bar>
                        <Link to="/login"><Button width="200px" colorScheme="gray">Continue with FaceBook</Button></Link>
                    </Bar>
                </Column>
            </Grid>
        </Rim>
    </Box>
)

export default Splash;
